import 'application/utils'
import 'shared/flash_message'
import 'shared/breadcrumbs_flexible'
import 'shared/smart_search'
import 'shared/pingator'
import 'application/soft_update'
import 'application/standard_tracking'
import searchTemplate from 'templates/search_buckets.hbs'

SOPHIA.searchTemplate = searchTemplate
